/*
 * Pre Bootstrap Handling
 *
 * This script must be the first script in our index.js.
 *
 * It needs to run before any jQuery, jQuery Plugin and Bootstrap jQuery Plugin initialization,
 * so we can manipulate the required CSS Classes on the Sidebar navigation elements before
 * the Plugins do their own handling.
 *
 */
const hasStorage = (type) => {
    let storage;
    try {
        storage = window[type];
        const x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && (// everything except Firefox
                e.code === 22 || // Firefox
                e.code === 1014 || // test name field too, because code might not be present
                // everything except Firefox
                e.name === 'QuotaExceededError' || // Firefox
                e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
            (storage && storage.length !== 0);
    }
};

const preNavigationHandling = () => {
    if (hasStorage('localStorage')) {
        const wrapperSelector = '#wrapper';

        const storageNameNavDropdownItemContainerIdOpened = 'Esearcher.navigation.last_open_target';

        const wrapper = document.querySelectorAll(wrapperSelector);
        if (wrapper.length) {
            if (!wrapper[0].classList.contains('extend')) {
                const openedNavDropdownItemContainerId = localStorage.getItem(storageNameNavDropdownItemContainerIdOpened);

                if (openedNavDropdownItemContainerId) {
                    const openedNavDropdownItemContainers = document.querySelectorAll(openedNavDropdownItemContainerId);

                    if (openedNavDropdownItemContainers.length) {

                        const parent = openedNavDropdownItemContainers[0].parentNode
                        const openedNavDropdownToggle = parent.querySelectorAll('.menu-group-head');

                        if (openedNavDropdownToggle.length) {
                            openedNavDropdownToggle[0].classList.remove('collapsed');
                        }

                        openedNavDropdownItemContainers[0].classList.add('show-always');
                        openedNavDropdownItemContainers[0].classList.add('show');
                    }
                }
            }
        }
    }
}

window.addEventListener('DOMContentLoaded', () => {
    preNavigationHandling();
});
